/* global LIBRARY_JSON */
require( './index.scss' );
const Library = require( './library' );


const library = new Library( LIBRARY_JSON );
console.log( LIBRARY_JSON );
console.log( library );
// const unsubscribe =
library.renderTo( document.getElementById( 'js-app' ) );



//////////////////
// WEBPACK FOOTER
// ./client/index.js
// module id = 7
// module chunks = 0